import {
  withDirectModifiedFields,
  withDirectModifiedFieldsKeepingFeeChanges,
} from 'utils/pendingChanges';

export class ApplicationFeesApiV2 {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getFeesSummaryByApplicationId({ applicationId }) {
    return withDirectModifiedFields(
      await this.#http.get(`/api/applications/${applicationId}/fees/summary`),
    );
  }

  async getFeesViewByApplicationId({ applicationId }) {
    return withDirectModifiedFieldsKeepingFeeChanges(
      await this.#http.get(`/api/applications/${applicationId}/fees/view`),
    );
  }
}
